import { render } from "./form-grid-gutters.vue?vue&type=template&id=66043d32"
import script from "./form-grid-gutters.vue?vue&type=script&lang=js"
export * from "./form-grid-gutters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__